import React from 'react'
import { List } from 'material-ui/List'

import StudentStagedForInviteItem from '../student-staged-for-invite-item'

const styles = {
    helpText: {
        fontSize: 11,
        fontWeight: 'bold',
        color: '#f44336'
    }
};


function StudentStagedForInviteList({ students }) {
  let studentListItems = students.map((student) => {
    return (
      <StudentStagedForInviteItem key ={student.key} student={student} />
    )
  })

  return (

    <List>
    <p style={styles.helpText}>To reset your invite list, refresh this page.</p>
      {studentListItems}
    </List>
  )
}

export default StudentStagedForInviteList



// WEBPACK FOOTER //
// ./src/views/components/student-staged-for-invite-list/index.js